/**
 * Core site metadata for the Trustpoint Healthcare Solutions brand experience.
 * Translation: Core site metadata for the Trustpoint Healthcare Solutions brand experience.
 */
export const siteMetadata = {
  siteName: "Trustpoint Healthcare Solutions",
  baseUrl: "https://trustpointhealthcare.com",
  defaultTitle: "Trustpoint Healthcare Solutions | Revenue Cycle Management",
  defaultDescription: "Maximize practice profitability with Trustpoint Healthcare Solutions. Expert revenue cycle management (RCM) built by clinicians to optimize medical billing.",
  defaultKeywords: [
    "healthcare",
    "revenue cycle management",
    "rcm",
    "medical billing",
    "clinician dashboard",
    "financial audit"
  ],
  contactEmail: "contact@trustpointhealthcare.com",
  socialImage: "/og.png",
  socialImageAlt: "Trustpoint Healthcare Solutions",
  navigationLinks: [
    { id: "dashboard", label: "Dashboard", href: "/#dashboard" },
    { id: "process", label: "Process", href: "/#process" },
    { id: "success", label: "Success", href: "/#success" },
    { id: "about", label: "About", href: "/#about" },
    { id: "faq", label: "FAQ", href: "/#faq" },
  ],
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${siteMetadata.baseUrl}/#organization`,
  name: siteMetadata.siteName,
  url: `${siteMetadata.baseUrl}/`,
  logo: {
    "@type": "ImageObject",
    url: `${siteMetadata.baseUrl}/assets/images/logo.png`,
    width: 320,
    height: 320,
  },
  image: `${siteMetadata.baseUrl}${siteMetadata.socialImage}`,
  description: "Maximize practice profitability with Trustpoint Healthcare Solutions. Expert revenue cycle management (RCM) built by clinicians to optimize medical billing.",
  email: siteMetadata.contactEmail,
  contactPoint: {
    "@type": "ContactPoint",
    email: siteMetadata.contactEmail,
    contactType: "sales",
    availableLanguage: "English",
  },
  knowsAbout: [
    "Revenue Cycle Management",
    "Medical Billing",
  ],
};
